import { LoadingState } from "@quest/murka-games-behavior-panther/dist";
import { ingenuity } from "@quest/base-core/dist";
import { IGameStates } from "@quest/base-core/dist/Interfaces";
import { SlotConstants } from "@quest/slot-core";
import { MainGame } from "./MainGame";

// This is only for adding coreModuleList in final game js else use gameConstants directly//
import { game } from "./CoreModuleList";
import { GameServerComm } from "./Platform/GameServerComm";
import { GameParserModel } from "./Platform/GameParserModel";
import { GameParser } from "./Platform/GameParser";
import { WrapperController } from "./Platform/WrapperController";
import { BaseGameStateGame } from "./states/BaseGameStateGame";
import { FreeGameStateGame } from "./states/FreeGameStateGame";

export class Game {
  public serverComm: GameServerComm;
  public parser: GameParser;
  public parserModel: GameParserModel;
  public wrapper: WrapperController;

  constructor(cdn:boolean) {
    this.parserModel = new GameParserModel();
    this.parserModel.setBalance(0);
    this.parserModel.setUserBalance(0);
    ingenuity.parserModel = this.parserModel;
    ingenuity.cdn = cdn;

    this.serverComm = new GameServerComm(this.parserModel);
    this.parser = new GameParser(this.parserModel);

    const stateObj: IGameStates = {
      load: LoadingState as any,
      [SlotConstants.baseGameState]: BaseGameStateGame as any,
      [SlotConstants.freeGameState]: FreeGameStateGame as any,
    };
    new MainGame(
      game.gameConstants.GAME_CONTAINER_DIV,
      {
        desktop: {
          width: 1280,
          height: 720,
        },
        mobile: {
          width: 1280,
          height: 720,
        },
        mobilePortrait: {
          width: 720,
          height: 1280,
        },
      },
      stateObj
    );

    this.wrapper = new WrapperController();
  }
}
(window as any).Game = Game;
(window as any).ingenuity = ingenuity;
